const jwt_customizer = {
    general: 'JWT 토큰을 사용자 지정하는 중에 오류가 발생했습니다. 나중에 다시 시도해주세요.',
    can_not_create_for_admin_tenant: '관리자 테넌트에 대해 JWT 토큰 사용자 지정을 만들 수 없습니다.',
};
export default Object.freeze(jwt_customizer);
